import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import animatedIcons from './constants/animated-icons';
import Paragraph from '../../../paragraph';
import Heading from '../../../heading';
import Box from '../../../box';
import Toggle from '../../../toggle';
import Stack from '../../../stack';
import Icon from '../../../icon';
import BlinkingIcon from '../../../blinking-icon';
import { iconsList } from '../../../icon/glyphs';

const DomainSelectorSpecialOffer = ({
  checked,
  disabled = false,
  tagIconGlyph = null,
  captions,
  onToggle,
}) => {
  const classes = classNames('ws-ui-paywall-special-offer', {
    'ws-ui-paywall-special-offer--active': checked,
  });

  return (
    <div className={classes}>
      <Stack>
        <div className="ws-ui-paywall-special-offer__title-wrapper">
          <Heading type="heading-3" appearance="accent">
            {captions.title}
          </Heading>
          <div className="ws-ui-paywall-special-offer__tag">
            {tagIconGlyph && <Icon glyph={tagIconGlyph} size={14} strokeWidth={2.5} type="white" />}
            <div className="ws-ui-paywall-special-offer__tag-title">{captions.tagTitle}</div>
          </div>
        </div>
        <Paragraph>
          <b>{captions.description}</b>
        </Paragraph>
      </Stack>
      <Box marginRight="spacing-3-xs">
        <Toggle size="extra-large" checked={checked} disabled={disabled} onChange={onToggle} />
      </Box>
      {animatedIcons.map(({ key, ...restProps }) => (
        <BlinkingIcon key={key} {...restProps} />
      ))}
    </div>
  );
};

DomainSelectorSpecialOffer.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    tagTitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  tagIconGlyph: PropTypes.oneOf([...iconsList, null]),
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

export default DomainSelectorSpecialOffer;
